// extracted by mini-css-extract-plugin
export var headerContainer = "styles-module--headerContainer--oInSk";
export var headerContainerH1 = "styles-module--headerContainer-h1--SD2GC";
export var headerContainerBloks = "styles-module--headerContainer-Bloks--X5AEG";
export var headerContainerBloksLinks = "styles-module--headerContainer-Bloks-links--xn6gJ";
export var headerContainerBloksLinksTo = "styles-module--headerContainer-Bloks-links-to--ZsK5m";
export var headerContainerBloksLinksToActive = "styles-module--headerContainer-Bloks-links-to-active--Oay16";
export var headerContainerBloksContent = "styles-module--headerContainer-Bloks-Content--+PHfr";